export const snqTodo = (s: string) =>
  // eslint-disable-next-line no-console
  console.log(`%c ${s}`, 'background: darkgray; color: black;');

// eslint-disable-next-line no-console
export const snqlogger = (...args) => console.info(...args);

// eslint-disable-next-line no-console
export const snqlogerror = (...args) => console.error(...args);
